function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20.79 5c-.246 0-.482.1-.672.29l-8.487 8.96L14.236 17l8.487-8.96c.37-.39.37-1.02 0-1.41l-1.27-1.34c-.189-.2-.426-.29-.662-.29zM9.737 18c.521 0 .947.45.947 1 0 1.1-.852 2-1.894 2-.161 0-.313-.02-.474-.05.294-.55.474-1.21.474-1.95 0-.55.426-1 .947-1zm-2.842 1c0-1.66 1.27-3 2.842-3 1.573 0 2.842 1.34 2.842 3 0 2.21-1.696 4-3.789 4-1.43 0-2.918-.78-3.789-2 .796 0 1.894-.69 1.894-2z",
  clipRule: "evenodd"
});

var SvgIcBrush = function SvgIcBrush(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcBrush, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_brush.0cbf97b6.svg";
export { ForwardRef as ReactComponent };